module.exports = __webpack_public_path__ + "static/media/res5.b78a72a2.jpg";